export class MetricInstance {
    constructor(
                nameOverride,
                timePeriod,
                decimalPlaces,
                annualizedCumulative,
                dailyMonthly,
                averageEnding,
                residuals,
                customTimePeriod,
                fixedTrailing,
                excessReturns,
                maxDecimalPlaces,
                includeMax, 
                sidePanelDisplayName){

            this.nameOverride = nameOverride;
            this.timePeriod = timePeriod;
            this.decimalPlaces =  decimalPlaces;
            this.dailyMonthly = dailyMonthly;
            this.averageEnding = averageEnding;
            this.annualizedCumulative = annualizedCumulative;
            this.customTimePeriod = customTimePeriod;
            this.fixedTrailing = fixedTrailing;
            this.residuals = residuals;
            this.excessReturns = excessReturns;
            this.maxDecimalPlaces = maxDecimalPlaces;
            this.includeMax = includeMax;
            this.sidePanelDisplayName = sidePanelDisplayName;
        }

}